exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ":host{background-color:#fff;display:none}:host:not(.hidden){display:block}:host label{z-index:10;color:#5a4e4e}:host small{color:#5a4e4e!important}:host .input-group-addon-btn{background-color:unset;border:unset}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["./~/bootstrap/scss/_functions.scss","./~/bootstrap/scss/_variables.scss","./src/main/webapp/content/scss/variables.scss"]}!./src/main/webapp/app/shared/components/forms/input/input.component.scss
// module id = 735
// module chunks = 0